import { createAsyncThunk } from '@reduxjs/toolkit'
import Issue from './issue-model'
import { delete_issue, load_issues, store_issue } from './issue-service'

export const LoadIssuesAsync = createAsyncThunk<any, any>(
  'composer/load/issue',
  async (params: { uid: string }) => {
    return await load_issues(params)
  },
)

export const CreateIssueAsync = createAsyncThunk<any, any>(
  'composer/create/issue',
  async (params: Issue) => {
    return await store_issue(params)
  },
)

export const DeleteIssueAsync = createAsyncThunk<any, any>(
  'composer/delete/issue',
  async (params) => {
    return await delete_issue(params)
  },
)
